module.exports = __webpack_public_path__ + "img/center_text11.97e48c0b.png";